<template>
  <span>
    <router-link v-if="client" :to="{name: 'client/view/info', params: { clientId: client.id }}">{{client.fullName || '-'}}</router-link>
    <template v-else><strong class="text-grey-darken-3">määramata</strong></template>
  </span>
</template>

<script>
export default {
  props: {
    client: {
      required: true
    }
  }
}
</script>
